module.exports = __webpack_public_path__ + "assets/img/3.01acaf8d.png";